import BackgroundPage from './BackgroundPage';
import FlexPage from './FlexPage';
import GraphPage from './GraphPage';
import InputPage from './InputPage';
import ResultPage from './ResultPage';
import ScrollPage from './ScrollPage';
import SwiperPage from './SwiperPage';

export { BackgroundPage, FlexPage, GraphPage, InputPage, ResultPage, ScrollPage, SwiperPage };
